import { Component } from '@angular/core';

@Component({
  selector: 'app-monitoring',
  imports: [],
  templateUrl: './monitoring.html',
  styleUrl: './monitoring.css',
})
export class Monitoring {

}
